import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private onboardingData = signal<{
    stepSelectCompanyCompleted?: boolean;
    stepUserInfoCompleted?: boolean;
    stepDescriptionCompleted?: boolean;
    drfeelUser?: true;
    email?: string;
    employeeId?: string;
    employeeIdContact?:
    | {
      employeeId: string;
      firstName: string;
      lastName: string;
    }
    | undefined;
    organization?: string;
    organizationDescription?: string;
    confirmData?: boolean;
    firstName?: string;
    gender?: string;
    groupRef?: string;
    lastName?: string;
    birthDay?: string;
    birthMonth?: string;
    birthYear?: string;
    birthDate?: string;
    birthCountry?: string;
    birthProvince?: string;
    birthCity?: string;
    birthPlace?: string;
  }>({});

  constructor(private http: HttpClient) { }

  updateData(data: any) {
    this.onboardingData.update((current) => ({ ...current, ...data }));
  }

  getData() {
    return this.onboardingData();
  }

  verifyEmployeeId(employeeId: string): Observable<boolean> {
    const url = `${environment.apiAdminUrl}/partner-pre-reg/by-partner/${environment.partnerName}/by-employId/${employeeId}`;
    return this.http.get(url).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}